import React, { Component } from "react";
import { API_TOKEN_NAME, IMAGE_URL, SITE_URL } from "../../../constants";
import { scAxiosAdmin } from "../../..";
// import search_icon from '../../../images/search-icon.png';
import { FiSearch } from "react-icons/fa";
import icons_rotate from "../../../images/icons-rotate.png";
import $ from "jquery";

const getDefaultSearch = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/homesetting/getdefaultsearchdata", {
      method: "get",
      headers: {
        Accept: "application/json",
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getSearchData = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/homesetting/getsearchdata", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getAllBannerButtonData = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/bannerbutton/getallbannerbtndata", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

class HomeSearch extends Component {
  state = {
    search_keywords: "",
    default_doctors: [],
    default_packages: [],
    default_publications: [],
    default_departments: [],
    bannerbuttons: [],
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  refreshGetDefaultSearchData = () => {
    getDefaultSearch()
      .then((res) => {
        if (res.status === true) {
          this.setState({
            default_doctors: res.doctor_data,
            default_packages: res.package_data,
            default_publications: res.publication_data,
            default_departments: res.department_data,
          });
        } else {
          this.setState({
            default_doctors: "",
            default_packages: "",
            default_publications: "",
            default_departmnents: "",
          });
        }
      })
      .catch((err) => {});
  };
  handleKeyUp = (event) => {
    const data = {
      keywords: this.state.search_keywords,
    };
    getSearchData(data)
      .then((res) => {
        if (res.status === true) {
          this.setState({
            default_doctors: res.doctor_data,
            default_packages: res.package_data,
            default_publications: res.publication_data,
            default_departments: res.department_data,
          });
        } else {
          this.setState({
            default_doctors: "",
            default_packages: "",
            default_publications: "",
            default_departmnents: "",
          });
        }
        this.setState({ enableShdo: false });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  refreshGetAllBannerButtonData = () => {
    getAllBannerButtonData()
      .then((res) => {
        if (res.status === true) {
          this.setState({
            bannerbuttons: res.data,
          });
        } else {
          this.setState({
            bannerbuttons: "",
          });
        }
      })
      .catch((err) => {});
  };
  showSearchResult = () => {
    $(".search-popup").show();
    $("body").click(function () {
      $(".search-popup").hide();
    });
    this.refreshGetDefaultSearchData();
  };
  componentDidMount() {
    this.refreshGetAllBannerButtonData();
  }
  render() {
    console.log(this.state.bannerbuttons);
    return (
      <div className="banner_part_search">
        <h1
          data-aos="fade-up"
          data-aos-duration="1000"
          style={{ color: "black", textAlign: "center" }}
        ></h1>
        <div
          className="center-search"
          data-aos="fade-up"
          data-aos-duration="1000"
          style={{ position: "relative", zIndex: "999" }}
        >
          <form className="d-flex">
            <div className="input-group mb-3 home_search_input_section">
              <input
                type="text"
                name="search_keywords"
                id="search_keywords"
                value={this.state.search_keywords}
                className="form-control physicans"
                placeholder="Search for your doctor. department or health screening package..."
                aria-label="Username"
                onChange={this.handleChange}
                onClick={this.showSearchResult}
                onKeyUp={this.handleKeyUp}
                aria-describedby="basic-addon2"
              />
              <span
                style={{ cursor: "pointer" }}
                className="input-group-text"
                value={this.state.search_keywords}
                onClick={this.showSearchResult}
                id="basic-addon1"
              >
                <img src="/assets/images/Search.png" alt="" />
              </span>

              <div className="search-popup-main" style={{ width: "100%" }}>
                <div className="search-popup dd" style={{ display: "none" }}>
                  <h4>Specialists</h4>
                  <hr className="lists-line" />
                  <div className="row mt-4">
                    {this.state.default_doctors.length > 0 ? (
                      this.state.default_doctors.map(
                        (default_search_doctor) => {
                          let doctor_name = default_search_doctor.doctor_name;
                          let new_doctor_name = doctor_name.replaceAll(
                            " ",
                            "-"
                          );
                          return (
                            <div className="col-lg-4 col-md-12 mt-4">
                              <div className="doctor-list">
                                <a
                                  href={
                                    SITE_URL +
                                    "/consultant/" +
                                    default_search_doctor.slug
                                  }
                                  style={{
                                    textDecoration: "none",
                                    color: "#212529",
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-5">
                                      {default_search_doctor.doctor_profile ? (
                                        <img
                                          src={
                                            IMAGE_URL +
                                            "/DoctorProfileImg/" +
                                            default_search_doctor.doctor_profile
                                          }
                                          alt="Bitmap-3"
                                          style={{
                                            height: "120px",
                                            width: "100%",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                                          alt="Bitmap-3"
                                          style={{
                                            height: "120px",
                                            width: "100%",
                                          }}
                                        />
                                      )}
                                    </div>
                                    <div className="col-7">
                                      <h6 style={{ fontSize: "14px" }}>
                                        {default_search_doctor.doctor_name}
                                      </h6>
                                      <p style={{ fontSize: "12px" }}>
                                        {default_search_doctor.degree}
                                      </p>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          );
                        }
                      )
                    ) : (
                      <div className="col-lg-12 col-md-12">
                        <div className="doctor-list">
                          <div className="row">
                            <p style={{ fontSize: "12px" }}>no result found</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <br />
                  <br />
                  <h4>Departments</h4>
                  <hr className="lists-line" />
                  <div className="row mt-4">
                    {this.state.default_departments ? (
                      this.state.default_departments.map((department) => {
                        let department_name = department.department_name;
                        // let new_doctor_name = doctor_name.replaceAll(' ', '-');
                        return (
                          <div className="col-lg-4 col-md-12 mt-4">
                            <div className="doctor-list">
                              <a
                                href={
                                  SITE_URL + "/departments/" + department.slug
                                }
                                style={{
                                  textDecoration: "none",
                                  color: "#212529",
                                }}
                              >
                                <div className="row">
                                  <div className="col-5">
                                    {department.image ? (
                                      <img
                                        src={
                                          IMAGE_URL +
                                          "/DepartmentImage/" +
                                          department.image
                                        }
                                        alt="Bitmap-3"
                                        style={{
                                          height: "120px",
                                          width: "100%",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                                        alt="Bitmap-3"
                                        style={{
                                          height: "120px",
                                          width: "100%",
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div className="col-7">
                                    <h6 style={{ fontSize: "14px" }}>
                                      {department_name}
                                    </h6>
                                    {/* <p style={{ "fontSize": "12px" }}>{default_search_doctor.degree}</p> */}
                                  </div>
                                </div>
                              </a>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-lg-12 col-md-12">
                        <div className="doctor-list">
                          <div className="row">
                            <p style={{ fontSize: "12px" }}>no result found</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <br />
                  <br />
                  <h5>Packages</h5>
                  <hr className="lists-line" />
                  <div className="row mt-4">
                    {this.state.default_packages.length > 0 ? (
                      this.state.default_packages.map(
                        (default_search_packages) => {
                          let package_name = default_search_packages.name;
                          let new_package_name = package_name.replaceAll(
                            " ",
                            "-"
                          );
                          console.log(default_search_packages);
                          return (
                            <div className="col-lg-4 col-sm-12">
                              <div className="Package-part">
                                <a
                                  href={
                                    SITE_URL + "/packages/" + new_package_name
                                  }
                                  style={{
                                    textDecoration: "none",
                                    color: "#212529",
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-md-4 sp-0-search">
                                      <img
                                        src={
                                          IMAGE_URL +
                                          "Packagesimg/202303221003packages%20Profile.png"
                                        }
                                        alt="icons-rotate"
                                      />
                                    </div>
                                    <div className="col-md-8 sp-0-search bg-color-gry">
                                      <h6 style={{ fontSize: "16px" }}>
                                        {default_search_packages.name}
                                      </h6>
                                      {/* <p title={default_search_packages.description} dangerouslySetInnerHTML={{ __html: default_search_packages.description ? default_search_packages.description.substr(0, 140) : '' }}></p> */}
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          );
                        }
                      )
                    ) : (
                      <div className="col-lg-12 col-sm-12">
                        <div className="Package-part">
                          <div className="row">
                            <p>No packages found</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <br />
                  <br />
                  {/* <h5>Blog</h5> */}
                  {/* <hr className="lists-line" /> */}
                  {/* <div className="row">
                    {this.state.default_publications.length > 0
                      ?
                      this.state.default_publications.map(default_search_publications => {
                        let publications_title = default_search_publications.publications_title;
                        let new_publications_title = publications_title.replaceAll(' ', '-');
                        return (
                          <div className="col-sm-6">
                            <a href={SITE_URL + '/publications/' + new_publications_title + '~' + default_search_publications.id} style={{ "textDecoration": "none", "color": "#212529" }}>
                              <h6 className="colo-dark" title={default_search_publications.publications_title}>{default_search_publications.publications_title.substr(0, 40)}</h6>
                            </a>
                            <p style={{ "fontSize": "14px" }} dangerouslySetInnerHTML={{ __html: default_search_publications.publications_desc ? default_search_publications.publications_desc.substr(0, 150) : '' }}></p>
                          </div>
                        )
                      })
                      :
                      <div className="col-sm-12">
                        <p className="pera-search">No any blog found</p>
                      </div>
                    }
                  </div> */}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div
          className="row  sp-top"
          style={{
            position: "relative",
            zIndex: "1",
            right: "0",
            left: "0",
            display: "flex",
            justifyContent: "center",
            scrollBehavior: "smooth",
          }}
        >
          <div className="col-xl-9 col-xxl-8">
            <div className="row">
              {this.state.bannerbuttons.length > 0
                ? this.state.bannerbuttons.map((banner_button) => {
                    let buttonSlug = banner_button.department_name
                      .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\\/]/gi, "")
                      .replace(/\s+/g, "-")
                      .replace(/-$/, "")
                      .toLowerCase();

                    // Old regex
                    // replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
                    // console.log("some data",banner_button.department_name,"sdssf",buttonSlug)
                    // .replace(/[\s_]+/g, '-')
                    // .toLowerCase();

                    return (
                      <div className="col-md-3 col-sm-6 mt-4 singleCartgories ">
                        <a
                          href={SITE_URL + "/departments/" + buttonSlug}
                          style={{ textDecoration: "none" }}
                        >
                          {/* <div className="excellence-part" data-aos="zoom-in" data-aos-duration="1000" style={{ width: "100%", maxWidth: "204px", margin: "0 auto" }}  > */}

                          <div
                            className="card cardHover "
                            style={{
                              width: "100%",
                              margin: "0 auto",
                              height: "62px",
                              display: "flex",
                              justifyContent: "center",
                              borderRadius: "31px",
                              backgroundColor: "#F3EFE8",
                            }}
                          >
                            <div
                              className="p-2 singledpt"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {banner_button.banner_btn_icon ? (
                                <img
                                  className="ql-background"
                                  src={
                                    IMAGE_URL +
                                    "BannerButtonImg/" +
                                    banner_button.banner_btn_icon
                                  }
                                  alt="avtars"
                                  style={{
                                    borderRadius: "50%",
                                    width: "100%",
                                    maxWidth: "27px",
                                  }}
                                />
                              ) : (
                                <i className="fa-solid fa-circle-right"></i>
                              )}
                              <p className="px-2" style={{ fontSize: "14px" }}>
                                {banner_button.banner_btn_text}
                              </p>
                            </div>
                          </div>
                          {/* <div className="row "  >
                      <div className="col-3">
                        {
                          banner_button.banner_btn_icon
                            ?
                            <img  className="ql-background" src={IMAGE_URL + 'BannerButtonImg/' + banner_button.banner_btn_icon} alt="avtars" style={{borderRadius:"50%",width:"46px",}} />
                            :
                            <i className="fa-solid fa-circle-right"></i>
                        }

                      </div>
                      <div className="col-9">
                       
                      </div>
                    </div> */}
                          {/* </div> */}
                        </a>
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
        </div>
        {/*<div className="row">
                  <div className="col-sm-4"></div>
                  <div className="col-sm-4 btn-banner">
                    <div className="contact-number">
                      <a href="tel:10666">
                        <div className="row">
                          <div className="col-4 text-center"><img src={hotline_phone} alt="hotline_phone"/></div>
                          <div className="col-8"> 
                            <p> <span>24*7 Hotline</span><br/>  10666</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>*/}
      </div>
    );
  }
}
export default HomeSearch;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/HomeSearch.js